<template>

    <section id="hero">

        <div class="content-wrapper">

            <!--transition name="slide-fade"-->
            <video-shade v-if="landing.hero.videoHasEnded" :shaded="landing.hero.videoHasEnded" :ended="landing.hero.videoHasEnded">

                <b-container class="shade-container">

                    <b-row align-v="center">

                        <b-col>

                            <div class="media-block">

                              <transition appear @enter="animateHeadline">
                                <h1 class="headline"
                                    v-html="landing.hero.headline"></h1>
                              </transition>

                                <img src="/static/images/balloons@1x.png"
                                     srcset="/static/images/balloons@1x.png 1x, /static/images/balloons@2x.png 2x, /static/images/balloons@3x.png 3x"
                                     class="headline-image"
                                     data-aos="slide-up"
                                     data-aos-duration="6000"
                                     data-aos-delay="250"
                                     data-aos-easing="ease-in-out-quad"
                                     data-aos-offset="0"
                                     data-aos-anchor="#hero"
                                     data-aos-anchor-placement="bottom-bottom"
                                     data-aos-once=""/>

                                <button class="replay-demo animated swing" @click="replayDemo">
                                    <span class="icon">
                                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1080 1080" style="enable-background:new 0 0 1080 1080;" xml:space="preserve">
                                            <g>
                                                <path d="M505.7,450.7c-5.5-2.3-18.2-6.8-24.5-6.8c-16.4,0-33.2,5.5-33.2,23.6v13.6l0,0.1v109.6V616c0,23.6,15.5,36.4,30,36.4 l21.4-8.4l0-0.1c52-20.9,110.3-45.9,141.4-64.6c16.8-10,25.9-20,25.9-35.5v-7.3C623.9,505.7,547.5,466.6,505.7,450.7z"/>
                                                <g>
                                                    <path d="M531.1,212.6c-107.3,0-202.7,51.8-262.6,131.7c1.4-10.6,3-19.8,4.5-25.3c3.7-14.3-5.2-33-21.2-44.1 c-3.8-2.6-8.3-5.1-13-6.5c-1.8,6.2-3.5,13.3-5.1,20.9c-9.2,43.9-14.4,106.2-13.1,132.7c0.8,10.5,2.5,24.2,11.8,30.7l8.8,6.2 c45.6-10.7,105.3-37.3,133-53.7c4-2.2,11.5-5.7,13.8-9.1c1.1-1.6,1.8-3.3,2.4-5c2.8-8.7-1.5-18.8-12.4-26.3l-7.6-5.3 c-12.9,7.9-30.7,16.6-48.8,24.8c47.7-63.7,123.8-105,209.3-105c144.1,0,261.4,117.3,261.4,261.4S675.2,801.9,531.1,801.9 c-6,0-11.9-0.3-17.8-0.7c-1.7-0.1-3.4-0.2-5-0.4c-5-0.4-10-1-14.9-1.7c-2.4-0.4-4.9-0.8-7.3-1.2c-3.4-0.6-6.7-1.2-10-1.9 c-3.2-0.7-6.4-1.4-9.5-2.2c-0.9-0.2-1.9-0.5-2.8-0.8c-71.8-19.2-131.4-68.2-164.9-132.9c-2.8-4.4-5.3-8.8-7.3-13.1 c-0.5-1-0.9-2-1.4-3.1c-15.7-34.5-20-74.2-10.9-108.7l-1.4-3.1l-19.7,15.5c-39.9,31.3-43,91.7-18.9,143.1 c2.4,5.2,6.8,12.9,13,21.7c27.2,43.8,64.3,80.9,108.3,107.8c0,0,0,0,0,0c0.3,0.2,0.7,0.4,1,0.6c0.4,0.3,0.9,0.5,1.3,0.8 c5.1,3.1,10.3,6,15.6,8.8c1.7,0.9,3.4,1.7,5.1,2.6c4.5,2.3,9.1,4.5,13.7,6.5c1.5,0.7,2.9,1.3,4.4,2c6,2.6,12,5,18.1,7.2 c1.3,0.5,2.5,0.8,3.8,1.3c5,1.8,10.1,3.4,15.2,4.9c1.9,0.6,3.8,1.1,5.7,1.6c5.4,1.5,10.8,2.8,16.2,4c1.1,0.2,2.2,0.5,3.3,0.8 c6.5,1.4,13.1,2.5,19.7,3.5c1.7,0.3,3.5,0.4,5.3,0.7c5.1,0.7,10.3,1.2,15.5,1.6c2,0.2,3.9,0.3,5.9,0.4c6.8,0.4,13.7,0.7,20.6,0.7 c180.8,0,327.9-147.1,327.9-327.9S711.9,212.6,531.1,212.6z"/>
                                                </g>
                                            </g>
                                        </svg>
                                    </span>
                                    <span class="label">{{ landing.hero.replayLabel }}</span>
                                </button>
                                <button class="contact-us animated swing" v-scroll-to="{ el: '#contact' }">
                                    <span class="label">{{ landing.hero.contactLabel }}</span>
                                    <span class="icon">
                                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1080 1080" style="enable-background:new 0 0 1080 1080;" xml:space="preserve">
                                            <path d="M485.5,282.8C485.5,282.8,485.5,282.7,485.5,282.8c-32.2-23.7-65.5-43.8-101.7-62.3c-30.3-15.8-51.2-10.6-83.4,6l-65.8,34 c60.6,27.2,128.2,68.8,195.3,114.7c0.1,0,0.1,0,0.2,0c37.2,23.7,73.8,48.4,109.2,73.9c42.2,30.6,79.2,58.9,122.6,91.3 c-43.3,32.4-80.4,60.7-122.6,91.3C482.9,672.1,424,711,363.7,746.2c-47.8,27.6-79.8,37-122.7,40.8c-2.7,50,8.3,70.2,53.7,79.2 c41.1,8.1,84.1-1.3,123.2-25C534.7,771.2,813.4,564.1,845,540.3C818.5,520.4,618.3,371.6,485.5,282.8z"/>
                                        </svg>
                                    </span>
                                </button>

                            </div>

                        </b-col>

                    </b-row>

                    <b-row class="simma d-none d-md-block" align-h="center">

                        <b-col>

                            <router-link to="about" v-scroll-to="{ el: '#about' }" class="scroll-link">
                                <div class="hand-holding-text">Scroll Down for More Stupendous!</div>
                                <div class="icon-scroll-down">
                                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1080 1080" style="enable-background:new 0 0 1080 1080;" xml:space="preserve">
                                        <path d="M846.1,212.1H741.3C689.6,349.7,603.8,520.2,540,615.8c-63.8-95.7-149.6-266.2-201.3-403.8H233.9c-42.4,0-65.9,22.4-65.9,60 c0,48.3,38.9,121.2,61.2,162.4C296.3,559.3,447,780.6,540,868.9c93-88.3,243.7-309.6,310.8-434.4c22.4-41.2,61.2-114.2,61.2-162.4 C912,234.4,888.5,212.1,846.1,212.1z"/>
                                    </svg>
                                </div>
                            </router-link>

                        </b-col>

                    </b-row>

                </b-container>

                <div class="strip strip_0"></div>
                <div class="strip strip_2"></div>
                <div class="strip strip_3"></div>

            </video-shade>
            <!--/transition-->

            <neo-video-controls ref="video_player" v-on:video-playing="videoPlaying" v-on:video-paused="videoPaused" v-on:video-ended="videoEnded" class="nvc" :classes="{ 'video-wrapper': true, 'video-ended': landing.hero.videoHasEnded }">
                <div id="hero-video" class="video-player">
                    <video :poster="landing.hero.posterSource.desktop.poster" preload autoplay playsinline muted id="video-0" width="100%" height="100%" data-setup="{}">
                        <source :src="landing.hero.videoSource.desktop.mp4" type="video/mp4" />
                    </video>
                </div>
            </neo-video-controls>

            <div class="credit" v-html="landing.hero.credit"></div>

        </div>
        <scroll-item id="si-demo" data-relid="demo" data-relpath="/" @change="onChange">
            <div class="gradient-wrapper"></div>
        </scroll-item>
    </section>

</template>


<script>

    import { mapGetters, mapActions } from 'vuex';
    import { UPDATE_VIDEO_STATUS } from '../store/app/actions';
    import AOS from 'aos';
    import VideoShade from "./VideoShade";
    import anime from 'animejs/lib/anime.es.js';
    import { SplitText } from '../vendors/gsap-bonus/SplitText';



    let vm = {};

    export default {

        name: 'Hero',

        components: {
            VideoShade
        },

        data() {
            return {
                isVideoPaused: false
            };
        },

        computed: {

            ...mapGetters('app', {
                landing: 'LANDING'
            }),

        },

        created() {
            vm = this;

            vm.$eventBus.$on('video::replay', function(evt) {
                vm.replayDemo(evt);
            });

            /* VIDEO EVENT LISTENERS */

            // video::ended
            document.addEventListener('video::ended', function() {
                vm.videoEnded();
            }, false);

            // video::paused
            document.addEventListener('video::paused', function() {
                console.log('%cvideo::paused', 'color:yellow;', 'event heard');
            }, false);

            // video::volumechanged
            document.addEventListener('video::volumechanged', function() {
                console.log('%cvideo::volumechanged', 'color:yellow;', 'event heard');
            }, false);

            /* END VIDEO EVENT LISTENERS */

        },

        mounted() {
            vm = this;
            AOS.refreshHard();
            vm.setupVideoObserver();
        },

        methods: {

            /**
             * @method replayDemo
             * @description
             * @param {Object} evt
             */
            replayDemo(evt) {
                console.log('%creplayDemo=>', 'color:dodgerblue;');
                if (evt) { evt.preventDefault(); }
                //this.videoHasEnded = false;
                this.updateVideoStatus(false);
                this.$refs.video_player.togglePlay();
            },

            contactUs(evt) {
                evt.preventDefault();
            },

            /**
             * @method videoPlaying
             * @description
             * @param {Object} evt
             */
            videoPlaying(evt) {
                console.log('%cvideoPlaying=>', 'color:dodgerblue;', evt);
                //this.videoHasEnded = false;
                this.updateVideoStatus(false);
            },

            /**
             * @method videoPaused
             * @description
             * @param {Object} evt
             */
            videoPaused(evt) {
                console.log('%cvideoPaused=>', 'color:dodgerblue;', evt);
            },

            /**
             * @method videoEnded
             * @description
             * @param {Object} evt
             */
            videoEnded(evt) {
                console.log('%cvideoEnded=>', 'color:dodgerblue;', evt);
                //this.videoHasEnded = true;
                this.updateVideoStatus(true);
            },

            /**
             * @method setupVideoObserver
             * @description
             */
            setupVideoObserver() {
                console.log('%csetupVideoObserver=>', 'color:dodgerblue;');

                //let _videoContainer = document.querySelector('#hero-video video');
                //console.log('_videoContainer', _videoContainer);

                // eslint-disable-next-line
                let _observer = new IntersectionObserver(function(entries, observer) {
                    entries.forEach(function(entry) {

                        //let _videoEl = entry.target;
                        //console.log('_videoEl', _videoEl);

                        let _videoElVisiblePct = (Math.floor(entry.intersectionRatio * 100) + '%');
                        console.log('_videoElVisiblePct', _videoElVisiblePct);

                        if (entry.intersectionRatio <= 0.8 && !vm.isVideoPaused) {
                            console.log('video out of view...pausing', entry.intersectionRatio);
                            vm.$refs.video_player.pauseVideo();
                            vm.isVideoPaused = true;
                        } else if (vm.isVideoPaused) {
                            console.log('video in view...playing', entry.intersectionRatio);
                            vm.$refs.video_player.playVideo();
                            vm.isVideoPaused = false;
                        }
                    });
                }, { threshold: 0.8 });

                _observer.POLL_INTERVAL = 100;

                console.log('vm.$refs.video_player.$el', vm.$refs.video_player.$el);

                _observer.observe(vm.$refs.video_player.$el);
            },

            /**
             * @method updateState
             * @description
             * @param {Object} state
             */
            updateState(state) {
                this.state = state;
            },

            /**
             * @method onChange
             * @description
             * @param {Object} state
             */
            onChange(state) {
                console.log('change', state);
            },

            /**
             * @method animateHeadline
             * @description
             * @param {Object} el
             * @param {Function} done
             */
            animateHeadline(el, done) {
                vm.checkIfTablet();

                let mySplitText = new SplitText('.headline', { type: 'words' });
                let chars = mySplitText.words;

                anime.timeline({ loop: false })
                    .add({
                        targets: chars,
                        duration: 2000,
                        opacity: [0, 1],
                        translateY: ['1.1em', 0],
                        easing: 'spring(1, 80, 10, 0)',
                        delay: function(el, i) {
                            return 45 * (i+1)
                        },
                        complete: () => {
                            done();
                        }
                    }, 300);
            },

            /**
             * @method checkIfTablet
             * @description
             */
            checkIfTablet() {
                if (vm.$md.tablet() || vm.$md.phone()) {
                    let balloons = document.getElementsByClassName('headline-image');
                    balloons[0].style.left = '0%';
                    balloons[0].style.top = '0%';
                }
            },

            ...mapActions('app', {
                updateVideoStatus: UPDATE_VIDEO_STATUS
            })

        }

    }

</script>


<style lang="scss" scoped>

    //@import '../assets/styles/helpers/variables';

    section {
        background: $black-100;
        color: rgba(255,255,255, 1.0);
        text-align: center;
        line-height: 0;
        padding: 0;
        position: relative;
        z-index: 5;
    }

    .gradient-wrapper {
        background: linear-gradient(135deg, $gradient-start 0%, $gradient-end 100%);
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;

        &::after {
            content: '';
            background: linear-gradient(135deg, $gradient-start 0%, $gradient-end 100%);
            width: 100%;
            height: 100%;
            opacity: 0.5;
            top: 0;
            left: 0;
            z-index: 1;
            transform: translate3d(0, 0, 0);
            filter: blur(20px);
        }
    }

    .content-wrapper {
        width: 100%;
        height: 100%;
        position: relative;
        top: 0;
        left: 0;
        z-index: 10;
    }

    .video-wrapper {
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: relative;
    }

    video {
        width: 100%;
        max-width: 100%;
        height: auto;
        position: relative;
        z-index: 1;
    }

    .shade-container {
        width: 100%;
        height: 100%;
        padding: 80px 0 80px 0;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        position: relative;
        top: 0;
        left: 0;
        z-index: 10;
        transition: all 0.3s $easeInOutQuad;

        @media (min-width: 576px) { // RED

        }

        @media (min-width: 768px) { // GREEN

        }

        @media (min-width: 992px) { // BLUE
            padding: 120px 0 150px 0;
            transition: all 0.3s $easeInOutQuad;
        }

        @media (min-width: 1200px) { // YELLOW

        }

        & img {
            max-width: 100%;
            height: auto;
        }
    }

    .image-wrapper {

    }

    .media-block {
        text-align: center;

        & h1 {
            font-family: $font-coconpro-bold;
            font-size: 1.250rem;
            font-weight: normal;
            line-height: 1;
            letter-spacing: -0.25px;
            color: $white-100;
            margin: 2.5rem 1rem 1.5rem 1rem;
            text-shadow: 0 0 8px rgba(122,85,159, 0.46);
            transition: all 0.3s $easeInOutQuad;

            @media (min-width: 576px) { // RED

            }

            @media (min-width: 768px) { // GREEN
                font-size: 2.50rem;
                margin: 2rem 0 2rem 0;
                padding: 0;
                transition: all 0.3s $easeInOutQuad;
            }

            @media (min-width: 992px) { // BLUE
                font-size: 3.750rem;
                margin: 3rem 0 5rem 0;
                transition: all 0.3s $easeInOutQuad;
            }

            @media (min-width: 1200px) { // YELLOW

            }

            & .blue {
                color: rgba(40,188,225, 1.0);
            }

            & .pink {
                color: rgba(251,94,211, 1.0);
            }
        }

        & button {
            background-color: $transparent;
            font-family: $font-coconpro-bolditalic;
            font-weight: normal;
            font-size: 1.0rem;
            line-height: 1;
            letter-spacing: -0.25px;
            outline: none !important;
            border: 0 none !important;
            max-height: 64px;
            margin: 0 15px;
            padding: 0.50rem 0.750rem;
            border-radius: 1.875rem !important;
            box-shadow: 7px 7px 0 rgba(69,60,151, 0.6);
            transform: translateX(0) translateY(0);
            transition: all 0.3s $easeInOutQuad;

            @media (min-width: 576px) { // RED

            }

            @media (min-width: 768px) { // GREEN
                font-size: 1.25rem;
                margin: 0 30px;
                padding: 0.750rem 1rem;
                transition: all 0.3s $easeInOutQuad;
            }

            @media (min-width: 992px) { // BLUE
                font-size: 1.875rem;
                margin: 0 60px;
                padding: 1.063rem 1.250rem;
                transition: all 0.3s $easeInOutQuad;
            }

            @media (min-width: 1200px) { // YELLOW

            }

            &:nth-of-type(1) {
                margin-left: 0;
            }

            &:nth-of-type(2) {
                margin-right: 0;
            }

            &:active,
            &:focus,
            &:disabled {
                outline: none !important;
                border: 0 none !important;
                box-shadow: 2px 1px 0 rgba(69,60,151, 0.6);
                transform: translateX(7px) translateY(7px);
                transition: all 0.3s $easeInOutQuad;
            }

            @media (hover:hover) {
                &:hover {
                    animation: rubberBand 1s;
                    transform-origin: 50% 50%;
                    transition: all 0.4s ease-in-out;
                }
            }

            & .label {
                text-shadow: 3px 2px 0 rgba(69,60,151, 0.65);
            }

            & .icon {
                width: 20px;
                height: 20px;
                display: inline-block;
                vertical-align: text-bottom;
                transform-origin: 50% 50%;
                transform: scale(1.5);
                transition: all 0.3s $easeInOutQuad;

                @media (min-width: 576px) { // RED

                }

                @media (min-width: 768px) { // GREEN
                    width: 24px;
                    height: 24px;
                    transition: all 0.3s $easeInOutQuad;
                }

                @media (min-width: 992px) { // BLUE
                    width: 30px;
                    height: 30px;
                    vertical-align: bottom;
                    transition: all 0.3s $easeInOutQuad;
                }

                @media (min-width: 1200px) { // YELLOW

                }
            }

            & path {
                fill: $white-100;
            }

            &.replay-demo {
                background-color: rgba(251,94,211, 1.0);

                & .icon {
                    margin: 0 0.5rem 0 0;

                    & svg {
                        filter: drop-shadow(2px 1px 0 rgba(69,60,151, 0.65));
                    }
                }
            }

            &.contact-us {
                background-color: rgba(40,188,225, 1.0);

                & .icon {
                    margin: 0 0 0 0.5rem;

                    & svg {
                        filter: drop-shadow(2px 1px 0 rgba(69,60,151, 0.65));
                    }
                }
            }
        }

        & .headline-image {
            max-width: 100%;
            height: auto;
            position: absolute;
            left: 50%;
            top: 35%;
            z-index: -1;
            filter: drop-shadow(16px 56px 20px rgba(63,62,138, 0.66));
            transform: translateX(-50%) translateY(-50%);
            animation: balloonBob 11s $easeInOutQuad infinite;
        }


    }

    .scroll-link {
        text-align: center;
        margin: 0 0 10px;
        display: inline-block;
        transition: all 0.3s $easeInOutQuad;

        @media (min-width: 576px) { // RED

        }

        @media (min-width: 768px) { // GREEN

        }

        @media (min-width: 992px) { // BLUE
            margin: 60px 0 30px;
            transition: all 0.3s $easeInOutQuad;
        }

        @media (min-width: 1200px) { // YELLOW

        }

        &:hover {
            animation: bounce 1.2s;
        }

        & .hand-holding-text {
            font-family: $font-coconpro-bolditalic;
            font-size: 1.0rem;
            font-weight: normal;
            line-height: 1;
            letter-spacing: -0.25px;
            color: $white-100;
            margin: 5px 0 3px;
            transition: all 0.3s $easeInOutQuad;

            @media (min-width: 576px) { // RED

            }

            @media (min-width: 768px) { // GREEN
                transition: all 0.3s $easeInOutQuad;
            }

            @media (min-width: 992px) { // BLUE
                font-size: 1.125rem;
                margin: 10px 0 3px;
                transition: all 0.3s $easeInOutQuad;
            }

            @media (min-width: 1200px) { // YELLOW

            }
        }

        & .icon-scroll-down {
            display: block;
            width: 30px;
            height: 30px;
            margin: 0 auto;

            & svg {
                filter: drop-shadow(4px 3px 0 rgba(69,60,151, 0.65));
            }

            & path {
                fill: $white-100;
            }
        }
    }

    .simma {
        width: 100%;
        margin: 0;
        display: block;
        position: absolute;
        bottom: 0;
        //top: 100vh;
        //transform: translateY(-100%);

        & a {
            text-decoration: none !important;
        }
    }

    .strip {
        width: 560px;
        height: 100%;
        //display: none;
        position: absolute;
        top: 0;
        transform-origin: 50% 50%;
        transform: skew(-45deg);

        &:nth-last-of-type(1) {
            background: linear-gradient(45deg, rgba(99,105,176,1) 0%,rgba(63,62,137,1) 100%);
            left: -300px;
        }

        &:nth-last-of-type(2) {
            background: linear-gradient(135deg, rgba(78,85,162,1) 0%,rgba(177,100,169,1) 100%);
            left: 253px;
            height: 100%;

            @media (min-width: 576px) { // RED

            }

            @media (min-width: 768px) { // GREEN
                left: 810px;
            }

            @media (min-width: 992px) { // BLUE

            }

            @media (min-width: 1200px) { // YELLOW

            }


        }

        &:nth-last-of-type(3) {
            background: linear-gradient(45deg, rgba(198,111,175,1) 0%,rgba(182,83,155,1) 100%);
            left: 1965px;
        }
    }

    .credit {
        font-size: 0.750rem;
        text-align: right;
        padding: 4px 8px;
        position: absolute;
        right: 0;
        bottom: -20px;
    }

</style>

<style lang="scss">

    .slide-fade-enter-active {
        transition: all .3s ease-in-out;
    }
    .slide-fade-leave-active {
        transition: all .4s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-fade-enter,
    .slide-fade-leave-to {
        transform: translateY(-800px);
        opacity: 0;
    }


    .progress-bar {
        background-color: transparent !important;
        flex-direction: row !important;
        justify-content: left !important;
    }
    .progress-bar__played {
        background: linear-gradient(135deg, rgba(78,85,162, 1.0) 0%, rgba(184,85,157, 1.0) 100%) !important;
    }
    .progress-bar__scrubber {
        background-color: rgba(184,85,157, 1.0) !important;
    }
    .progress-bar__buffered {
        background-color: rgba(61,179,206, 0.6) !important;
    }



    @keyframes balloonBob {
        0% {
            filter: drop-shadow(16px 56px 20px rgba(63,62,138, 0.66));
            transform: translateX(-50%) translateY(-50%);
        }
        50% {
            filter: drop-shadow(10px 86px 20px rgba(63,62,138, 0.36));
            transform: translateX(-50%) translateY(-53%);
        }
        100% {
            filter: drop-shadow(16px 56px 20px rgba(63,62,138, 0.66));
            transform: translateX(-50%) translateY(-50%);
        }
    }


    .video-wrapper {
        background-color: $black-100;

        &.video-ended {

            & video {
                opacity: 0;
                transition: opacity 0.2s ease-in-out;
            }
        }
    }

    .blue {
        color: rgba(40,188,225, 1.0);
    }

    .pink {
        color: rgba(251,94,211, 1.0);
    }

</style>
